const dragDropFile = {
  upload: {
    drag: 'Suelte su archivo aquí o',
    browse: 'Examinar sus archivos.',
  },

  uploaded: {
    success: 'El archivo {{name}} se cargó correctamente',
    chooseAnotherFile: 'Elija otro archivo.',
  },
};

export default dragDropFile;
